<template>
  <modal
    :show="true"
    :large="true"
    v-on:close="closeModal"
    :enable-event="!alertIsOpen"
  >
    <div slot="title">
      <h4>Edit Report</h4>
    </div>
    <div class="row">
      <fieldset
        :disabled="readonly"
        style="border:0;padding:0;margin:0;min-width:0;"
      >
        <div class="col-xl-12">
          <div class="form-horizontal">
            <inputbox
              v-model="form.incident_number"
              name="incident_number"
              helper="Please enter the incident number of the police report"
              label="Incident Number"
            ></inputbox>

            <inputbox
              v-model="form.officer_name"
              name="officer_name"
              label="Officer Name / No"
              helper="Please enter the officers name who created the report"
            ></inputbox>

            <inputbox
              v-model="form.telephone"
              name="telephone"
              label="Telephone"
              helper="Please enter a contact number for the police report"
            ></inputbox>

            <toggleswitch
              :labels="true"
              name="officer_attended"
              label="Did the officer attend the incident?"
              v-model="form.officer_attended"
            ></toggleswitch>

            <div class="form-group">
              <div class="col-lg-4">
                <label for="incident_reported_at" class="control-label"
                  >Incident Reported:</label
                >
                <p class="help-block">
                  According to the report, please enter the date when the
                  incident was reported.
                </p>
              </div>
              <div class="col-lg-8">
                <datepicker
                  format="dd/MM/yyyy"
                  :value="form.incident_reported_at"
                  v-on:selected="setIncidentReportedDate"
                  input-class="form-control"
                  placeholder="dd/mm/yyyy"
                ></datepicker>
              </div>
            </div>

            <div class="form-group">
              <div class="col-lg-4">
                <label for="report_requested_at" class="control-label"
                  >Report Requested:</label
                >
                <p class="help-block">
                  Please enter the date the police report was requested
                </p>
              </div>
              <div class="col-lg-8">
                <datepicker
                  format="dd/MM/yyyy"
                  :value="form.report_requested_at"
                  v-on:selected="setReportRequestedDate"
                  input-class="form-control"
                  placeholder="dd/mm/yyyy"
                ></datepicker>
              </div>
            </div>

            <div class="form-group">
              <div class="col-lg-4">
                <label for="report_received_at" class="control-label"
                  >Report Received:</label
                >
                <p class="help-block">
                  Please enter the date the report was received
                </p>
              </div>
              <div class="col-lg-8">
                <datepicker
                  format="dd/MM/yyyy"
                  :value="form.report_received_at"
                  v-on:selected="setReportReceivedDate"
                  input-class="form-control"
                  placeholder="dd/mm/yyyy"
                ></datepicker>
              </div>
            </div>

            <toggleswitch
              :labels="true"
              name="client_breathalysed"
              label="Was the Client Breathalysed?"
              v-model="form.client_breathalysed"
            ></toggleswitch>

            <toggleswitch
              :labels="true"
              name="third_party_breathalysed"
              label="Was the TP Breathalysed?"
              v-model="form.third_party_breathalysed"
            ></toggleswitch>
          </div>
        </div>
      </fieldset>
    </div>
    <div slot="footer">
      <div class="float-left">
        <form-button
          :indicator="indicator"
          v-on:clicked="deleteReport"
          level="danger"
          v-if="!readonly"
          >Delete</form-button
        >
      </div>
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button
        :indicator="form.processing()"
        v-on:clicked="updateReport"
        v-if="!readonly"
        >Update Report</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    report: {
      type: Object,
      required: true
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      alertIsOpen: false,
      form: new window.Form({
        incident_number: this.report.incident_number,
        officer_name: this.report.officer_name,
        telephone: this.report.telephone,
        officer_attended: this.report.officer_attended,
        incident_reported_at: this.report.incident_reported_at
          ? this.report.incident_reported_at
          : null,
        report_requested_at: this.report.incident_reported_at
          ? this.report.report_requested_at
          : null,
        report_received_at: this.report.incident_reported_at
          ? this.report.report_received_at
          : null,
        client_breathalysed: this.report.client_breathalysed,
        third_party_breathalysed: this.report.third_party_breathalysed
      }),
      indicator: false
    };
  },

  methods: {
    closeModal() {
      if (this.readonly) {
        this.$emit('close');
        return;
      }
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    deleteReport() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete(
              '/incidents/' +
                this.incident +
                '/police-reports/' +
                this.report.identifier
            )
              .then(response => {
                this.indicator = false;
                this.$emit('deleted', this.report);
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an issue deleting the report.'
                );
              });
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    updateReport() {
      this.form
        .put(
          '/incidents/' +
            this.incident +
            '/police-reports/' +
            this.report.identifier
        )
        .then(response => {
          this.$emit('updated', response);
        })
        .catch(response => {
          window.toastify.error('Please complete the required fields');
        });
    },

    setIncidentReportedDate(value) {
      this.form.incident_reported_at = value;
    },

    setReportRequestedDate(value) {
      this.form.report_requested_at = value;
    },

    setReportReceivedDate(value) {
      this.form.report_received_at = value;
    }
  }
};
</script>
